import { type RouteRecordRaw } from 'vue-router';
import MapView from '../components/views/MapView.vue';
import ActivityView from '../components/views/ActivityView.vue';
import ProfileView from '../components/views/ProfileView.vue';
import LoginView from '../components/views/LoginView.vue';

export enum RouteNames {
    MAP = 'map',
    ACTIVITY = 'activity',
    PROFILE = 'profile',
    LOGIN = 'login'
}

export const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        redirect: '/map'
    },
    {
        path: '/map',
        name: RouteNames.MAP,
        component: MapView,
        meta: { requiresLoggedIn: true }
    },
    {
        path: '/activity',
        name: RouteNames.ACTIVITY,
        component: ActivityView,
        meta: { requiresLoggedIn: true }
    },
    {
        path: '/profile',
        name: RouteNames.PROFILE,
        component: ProfileView,
        meta: { requiresLoggedIn: true }
    },
    {
        path: '/login',
        name: RouteNames.LOGIN,
        component: LoginView
    }
];